import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../base-form';
import { VisitasApiService } from '../../../../../service/api/visitas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { build, pool } from '../../../../../common/classes/request-builder';

import { VisitasSemanaModel } from 'src/app/models/visitas/visitas-semana.model';
import { VisitasSemanaFormDefinition } from './form-control/form-definition';
import type {
    ReactiveFormChangedField,
    ReactiveFormValue,
} from 'src/app/common/components/reactive-form-builder/interfaces/reactive-form-change.interface';

@Component({
    selector: 'app-visitas-semana-form',
    standalone: false,
    templateUrl: './visitas-semana-form.component.html',
    styleUrls: ['./visitas-semana-form.component.scss']
})
export class VisitasSemanaFormComponent extends BaseForm<VisitasSemanaModel> implements OnInit {
    public override model: VisitasSemanaModel = { semana: 0 };

    public form!: VisitasSemanaFormDefinition;

    public formReady = false;

    public constructor(
        public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public visitasApi: VisitasApiService,
        public fincasApi: FincasApiService,
        public formApi: FormCommonApiService,
        public override router: Router,
    ) {
        super(
            route,
            router,
            dashboard,
            visitasApi.visitasSemanaPUT,
            visitasApi.visitasSemanaPOST,
            'visitas-semana',
            'Actualizar Visita',
            'Crear Visita',
        );
    }// constructor();

    public async ngOnInit(): Promise<void> {
        this.form = new VisitasSemanaFormDefinition(this.getType(), this.model);
        await this.initFormData();
        this.softInit(this.getType());
        this.formReady = true;
    }// ngOnInit();

    public reactiveFormChanges(
        formModel: ReactiveFormValue<VisitasSemanaModel>,
        lastChangedFieldName: ReactiveFormChangedField<VisitasSemanaModel>,
    ): void {
        this.form.updateModel(formModel, lastChangedFieldName);
        this.model = this.form.model as VisitasSemanaModel;

        if (lastChangedFieldName === '__previous_data_patch' || lastChangedFieldName === '__dropdown_refresh') {
            this.applyLoadedReactiveState(lastChangedFieldName);
            return;
        }// if();

        this.formChanges(String(lastChangedFieldName ?? ''));
        this.formBuilderRef?.updateForm(this.form.model as Record<string, unknown>, false);
    }// reactiveFormChanges();

    public formChanges(_tag: string): void {
        this.dropdownsFinalized = true;
        this.dropdownLoadTrigger.next();
    }// formChanges();

    private initFormData(): Promise<boolean> {
        return pool([
            build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre'),
            build(this.fincasApi.parcelasGET, this.form.lists.parcelas, 'nombre', true),
        ], () => {
            this.dropdownsFinalized = true;
            this.dropdownLoadTrigger.next();
        }).then(() => true);
    }// initFormData();

    private applyLoadedReactiveState(lastChangedFieldName: ReactiveFormChangedField<VisitasSemanaModel>): void {
        this.form.updateModel(this.model as ReactiveFormValue<VisitasSemanaModel>, lastChangedFieldName);
        this.model = this.form.model as VisitasSemanaModel;
        this.formBuilderRef?.updateForm(this.form.model as Record<string, unknown>, false);
        this.dropdownsFinalized = true;
        this.dropdownLoadTrigger.next();
    }// applyLoadedReactiveState();
}
